/*jshint esversion: 6 */
import React, { Component } from 'react';
import { Row, Typography, Col} from "antd";
import Texts from "../../../utils/Text";
import aboutImg from "../../../utils/about.png";
import "./about.css";

const { Text } = Typography;


export default class About extends Component {
    state = {
        isMobile: window.screen.width < 769,
    }
    render() {
        return (
           <div style={{ minHeight: '853px'}}>
               <div className="about-content" style={{width: '100%'}}>
                   <Row style={{ fontSize: "36px", marginTop: '100px'}}>
                       <Text className="montserrat">{Texts('about', 'title')}</Text>
                   </Row>
                   <Row style={{alignItems: 'center'}}>
                       {this.state.isMobile ?
                           <>
                               <Row style={{ fontSize: "18px", marginTop: '36px'}}>
                                   <Text><b>VR Global</b> {Texts('about', 'description')}</Text>
                               </Row>
                               <Row style={{ fontSize: "18px"}}>
                                   <Text><b>VR Global</b> {Texts('about', 'description2')}</Text>
                               </Row>
                               <Row style={{ fontSize: "20px", marginTop: '30px'}}>
                                   <Text>Сотрудничество с <b>VR Global</b> предоставит Вам:</Text>
                               </Row>
                               <Row style={{ fontSize: "18px", marginBottom: '40px'}}>
                                   <li>
                                       <b>Экспертный подход. </b><Text>{Texts('about', 'services')[0]}</Text>
                                   </li>
                                   <li>
                                       <b>Снижение затрат.</b> Благодаря профессионализму <b>VR Global</b>, <Text>{Texts('about', 'services')[1]}</Text>
                                   </li>
                                   <li>
                                       <b>Индивидуальный подход к каждому клиенту. </b><Text>{Texts('about', 'services')[2]}</Text>
                                   </li>
                               </Row>
                           </>
                           :
                           <>
                               <Col className="montserrat text-col" span={15}>
                                   <Row style={{ fontSize: "18px"}}>
                                       <Text><b>VR Global</b> {Texts('about', 'description')}</Text>
                                   </Row>
                                   <Row style={{ fontSize: "18px"}}>
                                       <Text><b>VR Global</b> {Texts('about', 'description2')}</Text>
                                   </Row>
                                   <Row style={{ fontSize: "20px", marginTop: '30px'}}>
                                       <Text>Сотрудничество с <b>VR Global</b> предоставит Вам:</Text>
                                   </Row>
                                   <Row style={{ fontSize: "18px"}}>
                                       <li>
                                           <b>Экспертный подход. </b><Text>{Texts('about', 'services')[0]}</Text>
                                       </li>
                                       <li>
                                           <b>Снижение затрат.</b> Благодаря профессионализму <b>VR Global</b>, <Text>{Texts('about', 'services')[1]}</Text>
                                       </li>
                                       <li>
                                           <b>Индивидуальный подход к каждому клиенту. </b><Text>{Texts('about', 'services')[2]}</Text>
                                       </li>
                                   </Row>
                               </Col>
                               <Col span={9}>
                                   <div>
                                       <img className="img-col" src={aboutImg} alt={'about'} />
                                   </div>
                               </Col>
                           </>
                       }
                   </Row>
               </div>
           </div>
        );
    }
}

